/**
 * studio模块专用utils（偏业务）
 */
import { history } from 'umi';
import { MENU_ID_MAP, SLASH_G_POP } from '@gp/constants/const';

export interface IStudioDetailsPathUtilsParams {
  id?: string;
  name?: string;
}

export const getStudioDetailsPagePath = (params?: IStudioDetailsPathUtilsParams): string => {
  const { id, name } = params || {};
  if (!id) return '';
  const filter = encodeURIComponent(
    JSON.stringify({
      studioId: id,
      studioName: name || '',
      menuFrom: MENU_ID_MAP['studio-dashboard_studio-overall'], // 用于标识左侧菜单栏当前选中高亮
    }),
  );
  return `${SLASH_G_POP}/Studio/PortfolioOverview/Detail?filter=${filter}`;
};

export const goToStudioDetailsPage = (params: IStudioDetailsPathUtilsParams) => {
  const path = getStudioDetailsPagePath(params);
  if (!path) return;
  history.push(path);
};
